import React from 'react';
import { motion } from 'framer-motion';


// import { AppWrap } from '../../wrapper';
import { images } from '../../constants';
// import './Header.scss';



const Header = () => (

<>
{/* flex container */}

<div id="headers" className=" max-w-7xl  container flex flex-col-reverse md:flex-row items-center px-6 mx-auto mt-10 space-y-0 md:space-y-0 xl:items-center">


  
{/* left-item */}
<div className='flex flex-col mb-32 space-y-12 md:w-1/2 '>
  <h1 className='max-w-md text-4xl text-center md:text-3xl md:text-left'>
 
  
  
 I am  <br />
Hassan Abdihakin <br />
 <span className='text-blue-800 font-thin'>Data Analyst</span>
  </h1>
  <h1 className='max-w-sm text-center text-darkGrayishBlue md:text-left' >
  Excellent understanding and proficiency of platforms for effective data analyses, including Python, SQL, Excell,Tableau, IBM Cognos, and R.
   Strong Communication, organizational and analytical skills
  </h1>
  <div class="flex justify-center md:justify-start">
            <a
              href="#work"
              class="p-3 px-6 pt-2 border-8 shadow-lg  text-white bg-brightRed rounded-full baseline hover:bg-brightRedLight md:block"
              >See my Work</a
            >
          </div>

     

</div>
 {/* Image  */}
 
 <div className=" d:w-1/2   ">
          <img className='xl:max-w-3xl lg:max-w-3xl  2xl:max-w-5xl m ' src={images.wp1} alt="" />
          
        </div>

</div>


  

  
  </>
  
);

export default Header